<template>
  <div v-if="!userStore.user" class="page-container">
    <EmptyState :isUnauthorized="true" />
  </div>
  <div v-else class="page-container account-layout">
    <!-- Header commun -->
    <header class="page-header">
      <h1>Mon Compte</h1>

      <!-- Navigation par onglets -->
      <nav class="tabs-nav">
        <RouterLink
          :to="{ name: 'account.wallet' }"
          class="tabs-nav__link"
          active-class="is-active"
        >
          <span class="icon">🎫</span>
          Tickets
        </RouterLink>
        <RouterLink
          v-if="hasCurrentTrip"
          :to="{ name: 'account.driver' }"
          class="tabs-nav__link"
          active-class="is-active"
        >
          <span class="icon">🚗</span>
          Conducteur
        </RouterLink>
        <RouterLink
          :to="{ name: 'account.profile' }"
          class="tabs-nav__link"
          active-class="is-active"
        >
          <span class="icon">👤</span>
          Profil
        </RouterLink>
      </nav>
    </header>

    <!-- RouterView pour le contenu enfant -->
    <RouterView />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useUserStore } from '@/stores/userStore'
import { config } from '@/config/env'
import EmptyState from '@/components/EmptyState.vue'

const userStore = useUserStore()
const hasCurrentTrip = ref(false)

onMounted(async () => {
  await checkCurrentTrip()
})

async function checkCurrentTrip() {
  try {
    console.log('🔍 Cookies disponibles:', document.cookie) // ← LOG des cookies
    console.log('🌐 API URL:', config.apiUrl)

    const response = await fetch(config.apiUrl + '/trip/driver/current', {
      credentials: 'include'
    })

    console.log('📡 Response status:', response.status) // ← LOG du statut
    console.log('📋 Response headers:', Object.fromEntries(response.headers)) // ← LOG headers

    if (response.ok) {
      const data = await response.json()
      console.log('✅ Data reçue:', data) // ← LOG données
      hasCurrentTrip.value = !!data.uuid
    } else {
      const errorText = await response.text()
      console.error('❌ Erreur response:', errorText) // ← LOG erreur complète
    }
  } catch (err) {
    console.error('💥 Erreur fetch:', err)
    hasCurrentTrip.value = false
  }
}

</script>
<style scoped>
/* :deep(.empty-state) {
  margin-top: 4rem;
} */
.page-header {
  padding-bottom: 4rem;
}
.page-container {
  max-width: 1200px;
  margin: 0 auto;
}
@media (max-width: 768px) {
  .page-header {
    padding: 1rem 0 3rem;
  }
}

</style>
